import { createSlice } from "@reduxjs/toolkit";
import { getOTP } from './thunk';
export const initialState = {
  info: {},
  error: {}
};

const Auth = createSlice({
  name: 'Auth',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getOTP.fulfilled, (state, action) => {
      state.info = action.payload[0] || {};
    });

    builder.addCase(getOTP.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  }
});

export default Auth.reducer;